if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.id === "QuickViewProductContent") {
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
                   setTimeout(()=>{
                        BSS_B2B?.observer?.productSubject?.notifyObserver('ProductMutate', 'ProductPriceMutate');
                   }, 2000)
                }
                if (item.target.classList.contains("variant-option__selected-value")) {
                    BSS_B2B?.observer?.productSubject?.notifyObserver('ProductMutate', 'ProductPriceMutate');
                }               
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    setTimeout(() => {
        BSS_B2B?.observer?.productSubject?.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }, 3000)

}